<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/c3VCGv/tc-custom/9781455608102.jpg?1721404315792" alt="This image is the cover for the book Majestic Middle Tennessee, Majesty"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Majestic Middle Tennessee, Majesty
      </h1>
      <p class="bookDescription body article font2">
        <p>"The happy events, the human asides, historic happenings, and family legends . . . make its pages delightful to read. Smith writes warmly and with an easy appreciative wit." -The Tennesseean</p><p>Central Tennessee is a fascinating and historic area. Home to Andrew Jackson and James K. Polk, it was a major battleground during the Civil War. Majestic Middle Tennessee looks at ninety-five glorious antebellum homes in the central Tennessee region. Featured here are the sumptuous Rattle and Snap, the crown prince of them all; Mulberry Hill, where a Yankee stranger was mysteriously shot to death; and Foxview, home to children and cousins by the dozens. Hundreds of photographs and fascinating text detail the exciting and tragic history of each home.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Reid Smith
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Paddle Wheel Publications
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7240502e